<template>
  <div class="wrapper" :class="{ print: prepareForPrint }">
    <div class="image equipment-image" :class="{ print: prepareForPrint }">
      <img
        class="expandable-image"
        :src="machine.picture_url"
        alt="Imagem do equipamento"
        @click="showSingleImage(machine.picture_url)"
      />
    </div>
    <div class="image tag-image" :class="{ print: prepareForPrint }">
      <img
        class="expandable-image"
        :src="machine.ambra_tag_picture_url"
        alt="Imagem da tag"
        @click="showSingleImage(machine.ambra_tag_picture_url)"
      />
    </div>
    <div class="content border" :class="{ print: prepareForPrint }">
      <div class="row machine-details mb-3">
        <div v-on:click="openModal" class="col-4 col-md-4 machine-details__item editable">
          <b>Tag Equipamento:</b> {{ machine?.machine_tag || '' }}
        </div>
        <div v-on:click="openModal" class="col-4 col-md-4 machine-details__item editable">
          <b>Setor:</b> {{ machine?.company_sector?.name || '' }}
        </div>
        <div class="col-4 col-md-4 machine-details__item">
          <b>Data/hora coleta:</b> {{ '-' }}
        </div>
        <div v-on:click="openModal" class="col-4 col-md-4 machine-details__item editable">
          <b>Classe Equip:</b> {{ machine?.machine_class?.name || '' }}
        </div>
        <div v-on:click="openModal" class="col-4 col-md-4 machine-details__item editable">
          <b>Área:</b> {{ machine?.company_area?.name || '' }}
        </div>
        <div class="col-4 col-md-4 machine-details__item">
          <b>Acompanhante:</b> {{ acompanhanteDisplay }}
        </div>
        <div v-on:click="openModal" class="col-4 col-md-4 machine-details__item editable">
          <b>Tag Equip. Primário:</b> {{ machine?.primary_machine_tag || '' }}
        </div>
        <div v-on:click="openModal" class="col-4 col-md-4 machine-details__item editable">
          <b>Complemento:</b> {{ machine?.company_complement?.name || '' }}
        </div>
        <div class="col-4 col-md-4 machine-details__item">
          <b>Técnico:</b> {{ machine?.order_of_service?.agente || '-' }}
        </div>
        <div v-on:click="openModal" class="col-4 col-md-4 machine-details__item editable">
          <b>Tag Ambra:</b> {{ machine?.ambra_tag || '' }}
        </div>
        <div class="col-4 col-md-4 machine-details__item">
          <b>Multa máxima prevista:</b>
          R$ {{ maxMetrics?.total_max_fine_value || '0,00' }}
        </div>
      </div>

      <machine-metrics
        v-if="maxMetrics"
        :max-metrics="maxMetrics"
        :show-mondelez="isCompanyMondelez"
      ></machine-metrics>
    </div>
  </div>
  <Dialog
    :closable="false"
    :visible="displayModal"
    :style="{ width: '60vw' }"
    :modal="true"
    class="modal-content modal-machines"
  >
    <template #header class="modal-header">
      <h5 class="modal-title">Editar Equipamento</h5>
    </template>

    <div class="modal-body">
      <div class="offset-lg-2">
        <div class="row form-group">
          <div class="col-lg-10">
            <label>Tag equipamento</label>
            <div class="input-group">
              <input
                type="text"
                v-model="machineForm.machine_tag"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>Classe do equipamento</label>
            <div class="input-group">
              <AutoComplete
                v-model="machineForm.machine_class.name"
                :dropdown="true"
                :suggestions="filtered_company_class"
                field="name"
                class="w-100"
                @complete="filterCompanyClass($event)"
                @item-select="onCompanyClassSelect($event)"
              />
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>Tag do equipamento primário</label>
            <div class="input-group">
              <input
                type="text"
                v-model="machineForm.primary_machine_tag"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>Tag AMBRA</label>
            <div class="input-group">
              <input
                type="text"
                v-model="machineForm.ambra_tag"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>Setor</label>
            <div class="input-group">
              <AutoComplete
                v-model="machineForm.company_sector.name"
                :dropdown="true"
                :suggestions="filtered_company_sectors"
                field="name"
                class="w-100"
                @complete="filterCompanySectors($event)"
                @item-select="onCompanySectorSelect($event)"
              />
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>Área</label>
            <div class="input-group">
              <AutoComplete
                v-model="machineForm.company_area.name"
                :dropdown="true"
                :suggestions="filtered_company_areas"
                field="name"
                class="w-100"
                @complete="filterCompanyAreas($event)"
                @item-select="onCompanyAreaSelect($event)"
              />
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-lg-10">
            <label>Complemento</label>
            <div class="input-group">
              <AutoComplete
                v-model="machineForm.company_complement.name"
                :dropdown="true"
                :suggestions="filtered_company_complements"
                field="name"
                class="w-100"
                @complete="filterCompanyComplements($event)"
                @item-select="onCompanyComplementSelect($event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <button class="btn btn-danger" @click="closeModal()">Cancelar</button>
      <button class="btn btn-success" @click="updateMachine()">
        Salvar
      </button>
    </template>
  </Dialog>
</template>

<script>
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useStore } from 'vuex'

  import MachineMetrics from './MachineMetrics.vue'

  import Dialog from 'primevue/dialog'
  import AutoComplete from 'primevue/autocomplete'

  import useImageViewer from '@/modules/ImageViewer.js'

  import useCompanyAreas from '@/modules/CompanyArea.js'
  import useCompanyComplements from '@/modules/CompanyComplement.js'
  import useCompanySectors from '@/modules/CompanySector.js'
  import useMachineClasses from '@/modules/MachineClass.js'
  import useSwal from "@/modules/Swal";

  export default {
    setup() {
      const route = useRoute()
      const store = useStore()
      const company = computed(() => store.getters.selected_company)

      const { showSingleImage } = useImageViewer()

      const { company_sectors, listCompanySectors } = useCompanySectors()
      const { company_areas, listCompanyAreasBySector } = useCompanyAreas()
      const { company_complements, listCompanyComplementsByArea } =
        useCompanyComplements()
      const { machine_classes, listMachineClasses } = useMachineClasses()
      const { showSuccessDialog, showErrorDialog, showAjaxDialog } = useSwal()

      listMachineClasses()
      listCompanySectors(company.value?.id)

      return {
        showSingleImage,
        company,
        company_areas,
        company_complements,
        company_sectors,
        listCompanyAreasBySector,
        listCompanyComplementsByArea,
        machine_classes,
        listMachineClasses,
        showAjaxDialog,
        showErrorDialog,
        showSuccessDialog,
      }
    },
    components: {
      MachineMetrics,
      Dialog,
      AutoComplete,
    },
    data() {
      return {
        images: [],
        imageIndex: 1,
        imageVisible: false,
        displayModal: false,
        machineForm: {
          machine_tag: '',
          primary_machine_tag: '',
          ambra_tag: '',
          machine_class: {
            name: '',
          },
          company_sector: {
            name: '',
          },
          company_area: {
            name: '',
          },
          company_complement: {
            name: '',
          }
        },
        filtered_company_class: [],
        filtered_company_areas: [],
        filtered_company_complements: [],
        filtered_company_sectors: [],
      }
    },
    props: {
      machine: {
        type: Object,
        required: true,
      },
      maxMetrics: {
        type: Object,
        required: false,
        default: () => {},
      },
      isCompanyMondelez: {
        type: Boolean,
        required: true,
        default: false,
      },
      prepareForPrint: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      // Acompanhante vem de order_of_service.acompanhante_json (JSON salvo pela
      // coleta do app mobile) — antes o campo era hardcoded como '-' na tela,
      // nunca lia esse dado.
      acompanhanteDisplay() {
        const raw = this.machine?.order_of_service?.acompanhante_json

        if (!raw) return '-'

        try {
          const list = typeof raw === 'string' ? JSON.parse(raw) : raw

          if (!Array.isArray(list) || !list.length) return '-'

          const names = list
            .map((item) =>
              typeof item === 'string'
                ? item
                : item?.nome || item?.name || '',
            )
            .filter(Boolean)

          return names.length ? names.join(', ') : '-'
        } catch (e) {
          return '-'
        }
      },
    },
    methods: {
      openModal() {
        this.displayModal = true
      },

      closeModal() {
        this.displayModal = false
      },

      updateMachine: function() {
        let app = this
        let request = {
          url: '/api/machines/updateMachineData',
          data: new FormData(),
          config: {
            headers: {
              'content-type': 'multipart/form-data',
            },
          },
        }

        request.data.append('company_id', app.company.id)
        request.data.append('machine_id', app.machine.id)
        request.data.append('machine_tag', app.machineForm.machine_tag)
        request.data.append('machine_class[name]', app.machineForm.machine_class.name)
        request.data.append('primary_machine_tag', app.machineForm.primary_machine_tag)
        request.data.append('ambra_tag', app.machineForm.ambra_tag)
        request.data.append(
          'company_sector[name]',
          app.machineForm.company_sector.name,
        )
        request.data.append('company_area[name]', app.machineForm.company_area.name)
        request.data.append(
          'company_complement[name]',
          app.machineForm.company_complement.name,
        )

        this.showAjaxDialog(request)
          .then(function() {
            console.log('a')
            app.showSuccessDialog()
            app.closeModal()
          })
          .catch((error) => {
            console.log('a')
            let result = ''

            if (error && error.response.data) {
              let container = document.createElement('div')

              let paragraph = document.createElement('p')
              if (error.response.data.message) {
                paragraph.appendChild(
                  document.createTextNode(error.response.data.message),
                )
                paragraph.classList.add('alert')
                paragraph.classList.add('alert-danger')
              }

              let list = document.createElement('ul')
              for (let key in error.response.data.errors) {
                let itemElement = document.createElement('li')
                itemElement.appendChild(
                  document.createTextNode(error.response.data.errors[key]),
                )
                list.appendChild(itemElement)
              }

              container.appendChild(paragraph)
              container.appendChild(list)
              result = container
            }

            app.showErrorDialog(result)
          })
      },

      filterCompanyAreas(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_areas = [...this.company_areas]
          } else {
            this.filtered_company_areas = this.company_areas.filter(
              (company_area) => {
                return company_area.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      filterCompanyClass(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_class = [...this.machine_classes]
          } else {
            this.filtered_company_class = this.machine_classes.filter(
              (machine_class) => {
                return machine_class.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      filterCompanyComplements(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_complements = [...this.company_complements]
          } else {
            this.filtered_company_complements = this.company_complements.filter(
              (company_complement) => {
                return company_complement.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      filterCompanySectors(event) {
        setTimeout(() => {
          if (!event.query.trim().length) {
            this.filtered_company_sectors = [...this.company_sectors]
          } else {
            this.filtered_company_sectors = this.company_sectors.filter(
              (company_sector) => {
                return company_sector.name
                  .toLowerCase()
                  .startsWith(event.query.toLowerCase())
              },
            )
          }
        }, 250)
      },

      onCompanyAreaSelect(event) {
        this.machineForm.company_area.name =
          event.value.name.toLocaleUpperCase('pt-BR')
        this.listCompanyComplementsByArea(event.value.id)
      },

      onCompanyClassSelect(event) {
        this.machineForm.machine_class.name =
          event.value.name.toLocaleUpperCase('pt-BR')
        this.listMachineClasses(event.value.id)
      },

      onCompanyComplementSelect(event) {
        this.machineForm.company_complement.name =
          event.value.name.toLocaleUpperCase('pt-BR')
      },

      onCompanySectorSelect(event) {
        this.machineForm.company_sector.name =
          event.value.name.toLocaleUpperCase('pt-BR')
        this.listCompanyAreasBySector(event.value.id)
      },
    },
    mounted() {
      this.machineForm.machine_tag = this.machine.machine_tag
      this.machineForm.machine_class_id = this.machine.machine_class_id
      this.machineForm.primary_machine_tag = this.machine.primary_machine_tag
      this.machineForm.ambra_tag = this.machine.ambra_tag
      this.machineForm.machine_class.name = this.machine.machine_class.name
      this.machineForm.company_sector.name = this.machine.company_sector.name
      this.machineForm.company_area.name = this.machine.company_area.name
      this.machineForm.company_complement.name = this.machine.company_complement.name
    },
  }
</script>

<style lang="scss" scoped>
  .machine-details {
    padding: 20px;

    &__item {
      margin-top: 10px;
    }
  }

  .wrapper {
    display: flex;
    min-height: 300px;

    &.print {
      min-height: 200px;
      font-size: 0.7rem;
    }
  }

  .content {
    flex-grow: 1;

    &.print {
      max-height: 200px;
    }
  }

  .image {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 150px;
    // height: 100%;
    border: 1px solid #ccc;
    margin-right: 5px;
    text-align: center;

    img {
      object-fit: cover;
      max-width: 100%;
      max-height: 100%;
    }

    &.print {
      max-height: 200px;
      width: auto;

      img {
        object-fit: cover;
        max-width: 100%;
        max-height: 200px;
      }
    }
  }

  .expandable-image {
    cursor: pointer;
  }

  .editable {
    cursor: pointer;
  }
</style>
